export default {"src":"/_next/static/media/sharelink.a827a9b6.svg","height":32,"width":32};